import { compose } from 'ramda';
import { connect } from 'react-redux';

import Resources from 'components/Resources';
import withPageLoader from 'components/withPageLoader';

import { resourcesInitialize } from 'store/actionCreators/resources';
import { isResourcesAndStatuses, getResourcesShouldShowLoader } from 'store/selectors/resources';

const mapStateToProps = state => ({
  isData: isResourcesAndStatuses(state),
});

export default compose(
  withPageLoader({
    loadingSelector: getResourcesShouldShowLoader,
    initialAction: resourcesInitialize,
  }),
  connect(mapStateToProps),
)(Resources);
